import axios from "axios";

export const getPublicIp = () => {
  return axios.get("https://api.ipify.org?format=json", {
    withCredentials: false, 
  });
};
